import { render, staticRenderFns } from "./Triathlon.vue?vue&type=template&id=080a659c&scoped=true"
import script from "./Triathlon.vue?vue&type=script&lang=js"
export * from "./Triathlon.vue?vue&type=script&lang=js"
import style0 from "./Triathlon.vue?vue&type=style&index=0&id=080a659c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a659c",
  null
  
)

export default component.exports